import "./styles.css";

const InnerWrapper = ({ children, className, ...rest }) => {
  return (
    <div className={className || "innerWrapper"} {...rest}>
      {children}
    </div>
  );
};

export default InnerWrapper;
